var ScheduleResult = /** @class */ (function () {
    function ScheduleResult() {
        this.isActive = false;
        this.isDisabled = false;
        this.isRecommend = false;
    }
    ScheduleResult.prototype.toString = function () {
        return JSON.stringify(this);
    };
    ScheduleResult.toJSON = function (value) {
        return JSON.parse(value);
    };
    return ScheduleResult;
}());
export { ScheduleResult };
